<div class="news-container">
  <app-update-news></app-update-news>
  <app-media-upload></app-media-upload>
</div>
